// extracted by mini-css-extract-plugin
module.exports = {"wgi11fk":"wgi11fk"};